/**
 * Constants for onboarding table configuration
 */

import { CSSProperties } from "react";

export const ROUTES = {
  ONBOARDING_FORM: "/onboardingForm",
} as const;

export const MESSAGES = {
  NO_DATA: "No data matches your filters.",
} as const;

export const TABLE_STYLES = {
  headCell: {
    padding: "0.5rem 1.0rem",
    color: "#23262a",
  } as CSSProperties,

  bodyCell: {
    padding: "0.5rem",
  } as CSSProperties,
} as const;

export const DEFAULT_PAGINATION = {
  pageIndex: 0,
  pageSize: 10,
} as const;
